import { useMemo } from "react";

import { formatTimestamp } from "~/utils/helpers";

import { useMediaPlayerContext } from "../media/context";
import { MediaProgress } from "../media/MediaProgress";

import type { CSSProperties } from "react";

export function AudioTimeline() {
  const { currentTime, duration, seeking, seekingTime } =
    useMediaPlayerContext();

  const playheadTime = useMemo(
    () => (seeking ? seekingTime : currentTime),
    [currentTime, seeking, seekingTime],
  );

  const renderedDuration = useMemo(() => {
    return duration ? formatTimestamp(duration) : "-:-";
  }, [duration]);

  const customProperties = {
    "--timestamp-width": `${Math.max(renderedDuration.length - 1, 1)}ch`,
  } as CSSProperties;

  return (
    <div className="AudioTimeline" style={customProperties}>
      <div className="AudioTimeline__current-time">
        {formatTimestamp(playheadTime)}
      </div>

      <div className="AudioTimeline__progress">
        <MediaProgress />
      </div>

      <div className="AudioTimeline__duration">{renderedDuration}</div>
    </div>
  );
}
